import { useEffect, useState } from 'react';
import { admin_api } from '@/lib/api';
import { toast } from 'sonner';
import { Trash, Plus, Star } from '@phosphor-icons/react';

export default function AdminTestimonials() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ author_name: '', author_role: '', author_location: '', quote: '', rating: 5, published: true, featured: false });

  const load = async () => {
    setLoading(true);
    try { const res = await admin_api.testimonialsList(); setItems(res.items || []); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await admin_api.testimonialCreate({ ...form, rating: Number(form.rating) || 5 });
      toast.success('Testimonial added.');
      setForm({ author_name: '', author_role: '', author_location: '', quote: '', rating: 5, published: true, featured: false });
      load();
    } catch { toast.error('Could not add.'); }
  };

  const del = async (id) => {
    if (!window.confirm('Delete this testimonial?')) return;
    try { await admin_api.testimonialDelete(id); toast.success('Deleted.'); load(); }
    catch { toast.error('Could not delete.'); }
  };

  return (
    <div data-testid="admin-testimonials">
      <div className="mb-8">
        <div className="overline mb-2">Content</div>
        <h1 className="font-display font-extrabold text-3xl text-ink">Testimonials</h1>
      </div>

      <form onSubmit={create} className="p-6 rounded-2xl bg-white border border-neutral-200 mb-8 grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="admin-testimonial-form">
        <div>
          <label className="label-base">Author name</label>
          <input required value={form.author_name} onChange={e => setForm(f => ({...f, author_name: e.target.value}))} data-testid="admin-testimonial-name" className="input-base" />
        </div>
        <div>
          <label className="label-base">Role</label>
          <input value={form.author_role} onChange={e => setForm(f => ({...f, author_role: e.target.value}))} data-testid="admin-testimonial-role" className="input-base" placeholder="e.g. Support Coordinator" />
        </div>
        <div>
          <label className="label-base">Location</label>
          <input value={form.author_location} onChange={e => setForm(f => ({...f, author_location: e.target.value}))} data-testid="admin-testimonial-location" className="input-base" placeholder="e.g. Melbourne, VIC" />
        </div>
        <div>
          <label className="label-base">Rating (1-5)</label>
          <input type="number" min="1" max="5" value={form.rating} onChange={e => setForm(f => ({...f, rating: e.target.value}))} data-testid="admin-testimonial-rating" className="input-base" />
        </div>
        <div className="md:col-span-2">
          <label className="label-base">Quote</label>
          <textarea required rows={3} value={form.quote} onChange={e => setForm(f => ({...f, quote: e.target.value}))} data-testid="admin-testimonial-quote" className="input-base resize-none" />
        </div>
        <div className="md:col-span-2 flex items-center gap-6">
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={form.published} onChange={e => setForm(f => ({...f, published: e.target.checked}))} className="w-4 h-4 accent-brand" data-testid="admin-testimonial-published" /> Published
          </label>
          <label className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={form.featured} onChange={e => setForm(f => ({...f, featured: e.target.checked}))} className="w-4 h-4 accent-brand" data-testid="admin-testimonial-featured" /> Featured on home
          </label>
          <button type="submit" data-testid="admin-testimonial-submit" className="btn-primary !py-2 !px-4 text-sm ml-auto">
            <Plus size={14} weight="bold" /> Add testimonial
          </button>
        </div>
      </form>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="admin-testimonial-list">
        {loading && <div className="text-ink-muted">Loading…</div>}
        {items.map(t => (
          <div key={t.id} className="p-6 rounded-2xl bg-white border border-neutral-200">
            <div className="flex items-center justify-between mb-3">
              <div className="flex">
                {Array.from({ length: t.rating || 5 }).map((_, i) => (
                  <Star key={i} size={14} weight="fill" className="text-brand" />
                ))}
              </div>
              <button onClick={() => del(t.id)} data-testid={`admin-testimonial-delete-${t.id}`} className="text-ink-muted hover:text-red-500">
                <Trash size={16} />
              </button>
            </div>
            <blockquote className="text-sm text-ink mb-3">"{t.quote}"</blockquote>
            <div className="text-xs text-ink-muted">
              {t.author_name}{t.author_role ? ` · ${t.author_role}` : ''}{t.author_location ? ` · ${t.author_location}` : ''}
            </div>
            <div className="mt-2 flex gap-2 text-[10px] uppercase tracking-widest font-bold">
              {t.published && <span className="text-brand">Published</span>}
              {t.featured && <span className="text-green-600">Featured</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
